import { motion } from "framer-motion";
import { Lock, Star } from "lucide-react";
import { useT } from "@/i18n";

const MEDAL = {
  business: ["#a3e635", "#16a34a"], webdev: ["#fcd34d", "#f97316"], photography: ["#7dd3fc", "#2563eb"],
  games: ["#fb7185", "#db2777"], apps: ["#c084fc", "#7c3aed"], ai: ["#e879f9", "#7c3aed"], languages: ["#fde047", "#f59e0b"], story: ["#5eead4", "#0891b2"],
};

export function Badge3D({ stat, big = false }) {
  const { lang } = useT();
  const earned = stat.done >= stat.total && stat.total > 0;
  const [a, b] = MEDAL[stat.module_id] || ["#7dd3fc", "#2563eb"];
  const size = big ? 160 : 112;
  return (
    <motion.div className="flex flex-col items-center text-center" whileHover={earned ? { rotateY: 25, scale: 1.08 } : {}} style={{ perspective: 600 }} data-testid={`badge-${stat.module_id}`}>
      <div className={`badge-3d ${earned ? "badge-earned" : "badge-locked"}`} style={{ width: size, height: size, "--a": a, "--b": b }}>
        <div className="badge-ring">
          <img src={`/img/${stat.module_id}.webp?v=4`} alt="" className="w-[70%] h-[70%] object-contain drop-shadow-lg" />
        </div>
        {earned ? <Star className="badge-star w-7 h-7 text-yellow-300 fill-yellow-300" /> : <Lock className="badge-star w-6 h-6 text-slate-500" />}
      </div>
      <p className="mt-2 font-fredoka font-bold text-blue-950 text-sm leading-tight max-w-[9rem]">{stat.title?.[lang] || stat.title?.es}</p>
      <p className={`text-xs font-bold ${earned ? "text-green-700" : "text-slate-500"}`} data-testid={`badge-status-${stat.module_id}`}>
        {earned ? (lang === "es" ? "¡Ganada!" : "Earned!") : `${stat.done}/${stat.total}`}
      </p>
    </motion.div>
  );
}

export default function Badges({ stats, title }) {
  const { lang } = useT();
  if (!stats) return null;
  const earned = stats.filter((s) => s.done >= s.total && s.total > 0).length;
  return (
    <section className="bg-white/80 backdrop-blur-sm border-4 border-white rounded-[2rem] shadow-xl p-5 sm:p-8" data-testid="badges-section">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="font-fredoka text-2xl sm:text-3xl font-bold text-blue-950">{title || (lang === "es" ? "Mis insignias" : "My badges")}</h2>
        <span className="bg-yellow-300 rounded-full px-4 py-1.5 font-fredoka font-bold text-blue-950 shadow" data-testid="badges-count">{earned}/{stats.length}</span>
      </div>
      <p className="text-blue-900/80 font-semibold mt-1 text-sm">{lang === "es" ? "Completa todas las lecciones de un mundo para ganar su insignia." : "Finish every lesson in a world to earn its badge."}</p>
      <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-4 gap-5">
        {stats.map((s) => <Badge3D key={s.module_id} stat={s} />)}
      </div>
    </section>
  );
}
